/**
 * Copyright (c) 2026 上海安能聚创供应链管理有限公司.
 * All rights reserved.
 * 公司内部代码，未经书面授权，不得以任何形式复制、传播或用于与本项目无关的其他用途。
 */
import request from '@aned/request';

//  api/route/od/ODGoodsWeight 路由货量明细
export async function oDGoodsWeight(params) {
  return request('api/route/od/selectPage', {
    method: 'POST',
    body: params,
    // module: 'reports',
    reqType: 'json',
  });
}

//  api/route/od/ODGoodsWeightTotal 路由货量明细合计值
export async function oDGoodsWeightTotal(params) {
  return request('api/route/od/ODGoodsWeightTotal', {
    method: 'POST',
    body: params,
    // module: 'reports',
    reqType: 'json',
  });
}

// /api/route/od/ODGoodsWeight/export 导出列表
export async function odExport(params) {
  return request('api/route/od/ODGoodsWeight/export', {
    method: 'POST',
    body: params,
    // module: 'reports',
    reqType: 'json',
  });
}

// /api/route/od/ODGoodsWeight/exportInfo 导出明细（入参同导出列表）
export async function odExportInfo(params) {
  return request('api/route/od/ODGoodsWeight/exportInfo', {
    method: 'POST',
    body: params,
    // module: 'reports',
    reqType: 'json',
  });
}

// /api/route/od/ODGoodsWeight/exportCutoffVolume 导出分拨-分拨货量数据（分拨截单口径，仅总部有权限）
export async function odExportCutoffVolume(params) {
  return request('api/route/od/ODGoodsWeight/exportCutoffVolume', {
    method: 'POST',
    body: params,
    reqType: 'json',
  });
}

// 请求运营区列表
export async function requestApart(params) {
  const { startDate, endDate, keyword, ...rest } = params;
  return request(`api/route/od/selectParentSiteInfo`, {
    method: 'POST',
    body: {
      startDate,
      endDate,
      parentSiteName: keyword,
    },
    reqType: 'json',
  });
}

// 请求营运区列表
export async function requestCompany(params) {
  const { startDate, endDate, ...rest } = params;
  return request(`api/station/keyword/selectListsByKey`, {
    method: 'POST',
    body: {
      ...rest,
    },
    reqType: 'json',
    module: 'mdp-station-keyword',
  });
}
